<template>
  <div class="wrap2">
    <div class="tabbar_bg"></div>
    <div class="tabbar"  id="tabbar" @scroll="tabbarScroll">
      <div :class="filterclass(type)" :id="'tbitem'+index"  @click.stop="clickType(type,$event)" v-for="(type, index) in types" :key="index" >
        <span class="name" :class="filterclass2(type.name)">{{filtername(type.name)}}</span>
        <span class="num" v-if="type.num>0">{{type.num}}</span>
      </div>
    </div>
    <yum_draw_layout ref="drawerLayout" :drawerWidth="120"
                     :backdrop-opacity-range="[0,0.3]"
                     :drawer-width="120"  :animatable="true"  content-drawable>
      <div slot="drawer">
        <scroller class="bg-types">
          <div>
            <div class="search-box" @click.stop="clickSearch()">
              <div class="border-search-bt">
                <img src="../../assets/image/search.png" alt="">
                <span class="magin-l-6">搜索</span>
              </div>
            </div>
            <div :style="menuTypeStyle(type)" class="typeBtn font-1-1"
                 @click.stop="clickType(type)" v-for="(type, index) in types" :key="index"  >
              {{type.name}}
              <div class="type-num" v-if="type.num>0">{{type.num}}</div>
            </div>
          </div>
        </scroller>
      </div>
      <div slot="content">
        <!--<div class="home" @click="clickBackHome()">-->
          <!--<img src="../../assets/image/home.svg" width="39" height="39" >-->
        <!--</div>-->
        <!--<div v-if="state === 'enable'" @click="clickCommend()" class="DSAM" >-->
          <!--<img src="../../assets/image/recommed-Flash.gif" width="65" alt="">-->
        <!--</div>-->
        <!--<div style="position: absolute;top:0;left: 0;right: 0;z-index: 99;">-->
          <!--<typeTitle >-->
            <!--<div :class="{type_title_animation:!update}" v-html="title" v-cloak>-->
            <!--</div>-->
          <!--</typeTitle>-->
        <!--</div>-->
        <div class="cont" @scroll="handleScroll" ref="scroller">
          <!--<div class="bg-top" ></div>-->
          <!--<scroller ref="scroller">-->
          <div v-for="(type,index) in types" :id="type.code">
            <!--<div style="height: 35px; width:100%;opacity: 1;" v-show="index==0"></div>-->
            <typeTitle >{{type.name}}</typeTitle>
            <div class="swip" v-if="type.code==='tuijiancai' && recommendMenu.length>0 && state === 'enable'">
              <van-swipe class="my-swipe"  indicator-color="white" :autoplay="3000" @change="onSwipeChange">
                <van-swipe-item v-for="(item,index) in recommendMenu" :key="index">
                  <div class="xx" v-for="item2 of item.myarr" @click="clickCommend">
                    <div class="img" v-if="item2.defaultpic">
                      <img :src="item2.defaultpic" @error="imgerror"/>
                      <div>{{item2.menuItem.length}}菜搭配</div>
                    </div>
                    <div class="img" v-if="!item2.defaultpic">
                      <img src="../../assets/image/noimg.jpg"/>
                      <span>{{item2.menuItem.length}}菜搭配</span>
                    </div>
                    <div class="ctmsg">
                      <span>{{item2.title}}</span>
                    </div>
                    <div class="msg">{{item2.reason}}</div>
                  </div>
                </van-swipe-item>
              </van-swipe>
              <div  class="custom-indicator">
                <span v-for="(item,index) in recommendMenu" :class="index==swipeIndex?'checked':''"></span>
              </div>
            </div>
            <div v-for="order in type.menuItem" @click="clickOrder(order,type)">
              <bigPicMode v-if="order.picMode==1 && order.indexpicshow==1"  :order="order" :type="type">
                <div></div>
              </bigPicMode>
              <smallPicMode v-if="order.picMode==2 && order.indexpicshow==1" :order="order" :type="type" >
                <div></div>
              </smallPicMode>
              <noPicMode v-if="order.picMode==0 || (order.picMode>0 &&order.indexpicshow==0 )" :order="order" :type="type">
                <div></div>
              </noPicMode>
            </div>
          </div>
          <div style="height: 60px;"></div>
          <!--</scroller>-->

        </div >

        <div class="footer flex-layout">
          <div class="menu-bt magin-l-10"  @click.stop="clickBackHome()" >
            <img src="../../assets/image/home.png" width="20" height="20" style="vertical-align: middle">
          </div>
          <div class="menu-bt1" :style="carStyle(orderedTotal)" @click.stop="clickOrdered()" >
            <div class="color-yellow" v-if="orderedTotal.amount>0">{{orderedTotal.amount}}元</div>
            <img src="../../assets/image/cart.png" width="30" height="30" style="vertical-align: middle">
            <span class="carQty font-0-6" v-if="orderedTotal.count>0">{{orderedTotal.count}}</span>
          </div>
          <div class="menu-bt magin-r-10"  @click.stop="clickSearch()" >
            <img src="../../assets/image/search.png" width="30" height="30" style="vertical-align: middle">
          </div>

        </div>
      </div>
    </yum_draw_layout>
    <suitMode ref="suitMode"></suitMode>
    <no-suit-mode ref="nosuitMode"></no-suit-mode>
    <recommend v-if="state=='enable'" ref="recommend" :show="recommendShow" :hide="recommendHide"></recommend>
    <searchorder ref="searchorder"></searchorder>
    <alertnum ref="alertnum"></alertnum>
    <ordered ref="ordered" :boxshow="isShowOrdered()" :back-order="backOrder"></ordered>
    <takeout-ordered :takeout-ordered-is-show="outOrdered" :take-out-back="takeOutBack"></takeout-ordered>
  </div>
</template>

<script>
  import yum_drawer_layout from "../yum_drawer_layout/yum_drawer_layout";
  import bigPicMode from "../bigPicModel/bigPicMode";
  import ServiceUtils from "../../service/ServiceUtils";
  import smallPicMode from "../smallPicModel/smallPicMode";
  import noPicMode from "../noPicMode/noPicMode";
  import typeTitle from "../typeTitle/typeTitle";
  import ServiceHttp from "../../service/ServiceHttp";
  import ServiceLog from "../../service/ServiceLog";
  import suitmode from "../suitMode/suitmode";
  import nosuitmode from "../noSuitMode/nosuitmode";
  import recommend from "../recommend/recommend";
  import searchorder from "../searchOrder/searchorder";
  import alertnum from '../alertnum/alertNum';
  import ordered from "../ordered/ordered";
  import ServiceDialog from "../../service/ServiceDialog";
  import takeoutOrdered from "../ordered/takeoutOrdered";
  import 'vant/lib/swipe/style';
  import { Swipe, SwipeItem } from 'vant';
  import Vue from 'vue';
  Vue.use(Swipe)
  Vue.use(SwipeItem)

  export default {
    name: "orderv2",
    data(){
      return{
        recommendShow:false,
        state:'disable', //推荐菜是否启用状态  disable 未启用  enable 启用
        types:[],
        update:true,       //类型切换动画参数
        title:'',
        titleindex:0,//选中的菜类 index
        activeType:"",   //左边类型变色参数,
        showOrderd:false, //已点单参数
        orderedTotal:ServiceUtils.orderedTotal,//点菜概况
        yum_deaw_mask:false,             //侧边栏是否打开
        scrollY:0,
        outOrdered:false,            //外卖已点菜是否打开
        swipeIndex:0,
        recommendMenu:[],
        isClickTab:false,//是否点击tabbar了，如果点击了，就禁止tabbar滚动
      }
    },

    components:{
      'yum_draw_layout':yum_drawer_layout,
      'bigPicMode':bigPicMode,
      'smallPicMode':smallPicMode,
      'noPicMode':noPicMode,
      'typeTitle':typeTitle,
      'suitMode':suitmode,
      'noSuitMode':nosuitmode,
      'recommend':recommend,
      'searchorder':searchorder,
      'alertnum':alertnum,
      'ordered':ordered,
      'takeoutOrdered':takeoutOrdered,
    },
    watch:{
      title(val,oldval){
        for(let i in this.types){
          let item = this.types[i];
          if(item.name == val){
            this.titleindex = i;
            this.isInViewPortOfOne()
            break;
          }
        }
        this.update= false;
        setTimeout(()=>{
          this.update = true
        },500);
      }
    },

    methods:{
      onSwipeChange(index){
        this.swipeIndex = index;
      },
      imgerror(ev){
        ev.target.src = require('../../assets/image/noimg.jpg')
      },

      filterclass(type){
        let str = 'myitem'

        if(type.name == this.title){
          str+=' checked'
        }
        return str;
      },
      filterclass2(str){
        var pattern = new RegExp("[A-Za-z]+");
        if(pattern.test(str)){ //如果是英文
          return 'yin'
        }else{
          if(str.length>8){
            return 'zh fz06'
          }
          return 'zh'
        }
      },
      filtername(name){
        var pattern = new RegExp("[A-Za-z]+");
        if(pattern.test(name)){ //如果是英文
          return name;
        }else{
          if(name.length>4){
            return `${name.substring(0,4)}\n${name.substring(4,name.length)}`
          }else if(name.length>2 && name.length<=4){
            return `${name.substring(0,2)}\n${name.substring(2,name.length)}`
          }else{
            return name.substring(0,name.length)
          }
        }
      },

      getStroeNmae(){
        ServiceHttp.getStroeNmae((res)=>{
          if(res){
            ServiceUtils.changeTitle(res.name);
          }
        })
      },

      //已点单页面返回
      backOrder: function(){
        this.showOrderd = false;
      },
      //外卖已点单回调
      takeOutBack:function(){
        this.outOrdered = false;
      },

      clickBackHome(){
        let url = '/order/{0}/{1}/{2}/{3}'
          .format(ServiceUtils.config.sellerId,ServiceUtils.config.storeId,ServiceUtils.config.orderType,0);
        this.$router.replace({path:url});
      },


      handleScroll(e) {
        this.scrollY = e.target.scrollTop;
        this.scrollToType();
      },

      /**
       * 控制显示是否展示已点清单
       * */
      isShowOrdered(){
        if(this.showOrderd){
          return true;
        }else{
          return false;
        }
      },
      /**
       * 点击已点菜
       * */
      clickOrdered(){
        if(ServiceUtils.noSuitBillData.length == 0 && ServiceUtils.suitBillData.length == 0){
          ServiceDialog.showAlert('温馨提示','您尚未点菜，请您先点菜');
          return;
        }
        // this.showOrderd = true;
        if(ServiceUtils.config.orderType ==2){
          //外卖
          this.outOrdered = true;
        }else {
          //堂食 自提
          this.showOrderd = true;
        }
      },

      /**
       * 搜索菜品
       */
      clickSearch(){
        this.$refs.searchorder.togglebox();
        setTimeout(()=>{
          this.$refs.drawerLayout.toggle(false,(res)=>{
            this.yum_deaw_mask = res;
          });
        },500);
      },
      /**
       * 推荐菜隐藏
       * */
      recommendHide: function(){
        this.recommendShow = false;
      },
      /**
       * 点击推荐菜
       * **/
      clickCommend(){
        this.recommendShow = true;
      },
      /**
       * 购物车有数据 样式加宽
       * */
      carStyle(orderedTotal){
        if(orderedTotal.amount > 0){
          return "width :115px"
        }else {
          return "width :45px"
        }
      },
      /**
       * 点击底部菜单  出现侧边栏
       * */
      click(){
        this.$refs.drawerLayout.toggle(!this.yum_deaw_mask,(res)=>{
          this.yum_deaw_mask = res;
        });
      },
      /**
       * 左边菜单类型样式
       * */
      menuTypeStyle(type){
        if(type.code==this.activeType.code){
          return " background-color: #f5f3e6;"
        }else{
          return " background-color: #FDFCF8;"
        }
      },
      /**
       * 点击菜品类型
       * */
      clickType(item,ev){
        let clientWidth = document.body.clientWidth; //屏幕宽度
        console.dir(document.getElementById('tabbar'))
        // document.getElementById('tabbar').scrollTo(100,0)
        this.$refs.scroller.scrollTo(0,document.getElementById(item.code).offsetTop+2);
        this.scrollToType();
        this.activeType = item;
        this.title=item.name;
        this.isClickTab = true;
      },
      /**
       * 滑动到某个类别
       * */
      scrollToType(){
        this.types.forEach((type,i)=>{
          if(this.scrollY<0){
            return;
          }
          if(this.activeType == type) return;
          let _y = document.getElementById(type.code).offsetTop;
          let bty = document.getElementById(type.code).offsetHeight + _y;
          if(Math.abs(this.scrollY)>=_y && Math.abs(this.scrollY)<bty){
            this.title = type.name;
            this.activeType = type;
            return ;
          }
        });
      },
      /**
       * 获取推荐菜状态
       */
      getRecommendAtionSatate(){
        ServiceHttp.getRecommendAtionSatate(res =>{
          console.log('进来了,',res)
          if(res){
            this.state = res.state ;
            //如果启用了推荐菜，那就设置推荐菜
            if(this.state === 'enable' && ServiceUtils.menuData.length>0){
              this.initRecommendData();
            }else{
              this.types =ServiceUtils.menuData;
              this.title = this.types[0].name;
              this.activeType = this.types[0];
            }
          }
        })
      },
      /**
       * 点击菜品
       *
       * */
      clickOrder(order,type){
        if(this.yum_deaw_mask){
          this.$refs.drawerLayout.toggle(false,(res)=>{
            this.yum_deaw_mask = res;
          });
          return;
        }
        ServiceLog.print("order:",order);
        ServiceLog.print("type:",type);
        // 有估清数据  不能点菜
        if(order.isSaleout)return;
        order.num = 1;
        if(type.isGroup==0){
          console.log(this.$refs.nosuitMode)
          if(order.memoflag==1){
            //呼叫配菜
            this.$refs.nosuitMode.togglebox(type,order);
          }else if(order.remark.length>0){
            //有加菜项
            this.$refs.nosuitMode.togglebox(type,order);
          }else if(order.picMode!=0){
            //有图
            this.$refs.nosuitMode.togglebox(type,order);
          }else if(order.standards.length>1){
            //多规格
            this.$refs.nosuitMode.togglebox(type,order);
          }else {
            //弹框点菜
            this.$refs.alertnum.togglebox(type,order,function(food){
              let type = {
                code:food.code,
                name:food.name,
                ename:food.sndname||"",
                isGroup:0
              };
              let order = food.menuItem;
              ServiceUtils.setNoSuitData(type,order);
            });
          }
        }else {
          //  套餐
          console.log("套餐",order);
          this.$refs.suitMode.togglebox(order);
        }
      },
      /**
       * 获取背景图片
       */
      getBgPic() {
        ServiceHttp.getBgPic((res)=> {
          if(res){
            ServiceUtils.setOpenSmartSort(res.openSmartSort);
          }else {
            ServiceUtils.setOpenSmartSort(0);
          }
          if(res && res.openSchemaMenu === 1){
            this.getLoadData(true);//获取时效菜谱
          }else {
            this.getLoadData();
          }
        });
      },
      /**
       * 初始方法
       * */
      getLoadData(openSchemaMenu){
        /**
         * 获取图片数据
         * */
        ServiceHttp.getPicData(openSchemaMenu,()=>{
          /**
           * 获取原始菜单数据
           * */
          ServiceHttp.getOriginMenuData(()=>{

            ServiceUtils.sortPicMode(ServiceUtils.getOpenSmartSort()) ; //判断是否智能排序
            this.loadSaleOutData();
          });
          /**
           * 获取配菜数据
           */
          ServiceHttp.getSideDish();
        });
      },
      /**
       * 获取沽清数据
       */
      loadSaleOutData(){
        ServiceHttp.getSaleOutData(()=>{
          ServiceUtils.dealSaleOut();
          this.getRecommendAtionSatate();
        })
      },

      tabbarScroll(ev){

      },
      //判断选中的元素是否显示在可视区域，如果不在可视区域，就滑动到可视区域
      isInViewPortOfOne () {
        if(this.isClickTab){
          this.isClickTab = false;
          return;
        }
        let tabbar = document.getElementById('tabbar');
        let el = document.getElementById('tabbar').children[this.titleindex];
        // viewPortWidth 兼容所有浏览器写法
        const viewPortWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        const offsetLeft = el.offsetLeft;
        const offsetLeft2 = el.offsetLeft+25;//52是每一个条目的宽度，因为元素的offsetLeft不包括自身的宽度

        // console.log(`滚动的大小${tabbar.scrollLeft}，，屏幕宽度${viewPortWidth},,offsetLeft${offsetLeft2}}..titleindex${this.titleindex}`)
        // 滚动条滚动的大小+屏幕宽度的一半 < 选定元素的距离左边的宽度
        if(tabbar.scrollLeft+(viewPortWidth/2) < offsetLeft2){
          document.getElementById('tabbar').scrollTo(offsetLeft2-(viewPortWidth/2),0);
        }

        if(offsetLeft-(viewPortWidth/2) < tabbar.scrollLeft){
          // document.getElementById('tabbar').scrollTo(offsetLeft,0);
          document.getElementById('tabbar').scrollTo(offsetLeft2-(viewPortWidth/2),0);

        }
      },

      /**
       * 获取推荐菜
       * */
      initRecommendData:function () {
        ServiceHttp.getRecommendMenu(res=>{
          if(res){
            res.forEach((type)=>{
              type.menuItem = [] ;
              type.items.forEach((item)=>{
                if(ServiceUtils.menuItemDataMap[item.itemcode]){
                  type.menuItem.push(ServiceUtils.menuItemDataMap[item.itemcode])
                }
              });
            });
            let splitArray =  function(arr,len){
              let a_len = arr.length;
              let result = [];
              for(let i=0;i<a_len;i+=len){
                let myarr = arr.slice(i,i+len);
                for(let item of myarr){
                  item.defaultpic = '';
                  for(let item2 of item.menuItem){
                    if(item2.picPath){
                      item.defaultpic = item2.picPath;
                      break;
                    }
                  }
                }
                let obj = {index:i,myarr};
                result.push(obj)
              }
              return result
            }
            res = splitArray(res,2)
            this.recommendMenu.length = 0;
            this.recommendMenu = res;

            if(res.length==0) return;
            let obj = []
            if(this.state == 'enable'){
              obj = [{code: "tuijiancai", isGroup: 0, menuItem: [], name: "搭配推荐", sndname: ""}];
            }
            this.types = [...obj,...ServiceUtils.menuData];
            this.title = this.types[0].name;
            this.activeType = this.types[0];
            this.$forceUpdate();
            console.log("console.log(this.types);",this.types);
          }
        });
      },
    },
    mounted() {
      let body =  document.getElementsByTagName("body")[0];
      body.style.height = "100%";
      let params = this.$route.params ;      //url参数
      ServiceUtils.config.sellerId = params.sellerId;
      ServiceUtils.config.storeId = params.storeId;
      ServiceUtils.config.orderType = params.orderType;
      if(ServiceUtils.config.orderType==0 || ServiceUtils.config.orderType==1){ //堂食和自提用 堂食菜谱
        ServiceUtils.config.menuClass = 0;
      }else{ //用外卖菜谱
        ServiceUtils.config.menuClass = 1;
      }
      if(params.tableNo == 'no'){
        ServiceUtils.config.tableNo = '';
        ServiceUtils.config.isTakeTable = false;
      }else {
        ServiceUtils.config.tableNo = params.tableNo;
        ServiceUtils.config.isTakeTable = true;
      }
      this.getBgPic();
      this.types = ServiceUtils.menuData;

      // //临时测试
      // for(let i in this.types){
      //   let item = this.types[i];
      //   if(i==0){
      //     item.name = '套餐';
      //   }else if (i==1){
      //     item.name = '热食 亚洲美味';
      //   }else if (i==2){
      //     item.name = '早午餐brunch';
      //   }else if (i==3){
      //     item.name = '三明治 全麦高纤';
      //   }else if (i==4){
      //     item.name = '沙拉 轻食代餐';
      //   }else if (i==5){
      //     item.name = '藜麦卷高纤组合';
      //   }else if (i==6){
      //     item.name = '酸奶系列';
      //   }else if (i==7){
      //     item.name = '披萨 含百分之11膳食纤维';
      //   }else if (i==8){
      //     item.name = '咖啡 两种奶类';
      //   }else if (i==9){
      //     item.name = '热饮类';
      //   }
      // }
      console.log("ServiceUtils.menuData",ServiceUtils.menuData)

      this.getStroeNmae();
      console.log(ServiceUtils.config);
      /**
       * 如果是外卖则弹框提示
       */
      if(ServiceUtils.config.menuClass ===1){
          ServiceHttp.getSellerTakeoutConfig(res => {
              if (res && res.length > 0) {
                   Object.assign(ServiceUtils.takeoutConfig, res[0]);
//                  ServiceUtils.takeoutConfig.telephone = res[0].telephone;
//                  ServiceUtils.takeoutConfig.address = res[0].address;
                  ServiceDialog.OpenUserTakeoutSet(res[0]);
              }
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/style";
  .flex-layout{ display: flex;  align-items: center;}
  .footer{
    position: fixed;
    height: 60px;
    width: 100%;
    bottom: 10px;
    left: 0;
    /*background-color: rgba(0, 0, 0, 0.7);*/
    flex-direction: row;
    justify-content: space-between;
    color: white;
  }
  .bg-top{
    position: absolute;top:35px;left: 0;right: 0;height: 50px;
    background-image: url("../../assets/image/yumManufacture.svg");
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 60%;
  }
  .menu-bt{
    width: 45px;
    height: 45px;
    border-radius: 30px;
    background-color: rgba(0, 0, 0, 0.7);
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .menu-bt1{
    width: 45px;
    height: 45px;
    border-radius: 30px;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    position: relative;
    .color-yellow{
      margin-left: 5px;
    }
  }
  .bg-types{
    background-color: #FDFCF8;
  }
  .search-box{
    display: block;
    width: 100%;
    text-align: center;
    height: 40px;
    background-color: #7F6437;
    color: #ffffff;
    box-shadow: none;
    border-radius: 0;
    border: 0;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: center;
    font-size: 14px;
    padding-top: 10px;
  }
  .search-box img{
    vertical-align: middle;
    width: 22px;
    padding-bottom: 2px;
    pointer-events: none;
  }
  .type-num{width: 20px;height: 20px;background: red;line-height: 20px;
    text-align: center; color: white;border-radius: 10px;
    position: absolute;top:10px;right: 15px;
    font-size:0.8em;
  }
  .border-search-bt{
    margin: auto;
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 5px;
    border: 1px solid #c3ad97;
    text-align: left;
    padding-left: 5px;
  }
  .typeBtn{
    display:flex;
    align-items:center;
    overflow: hidden;
    /*width: 100%;*/
    border: 0;
    height: 70px;
    position: relative;
    text-align: left;
    padding-left: 10px;
    padding-right: 4px;
    background-image: url('../../assets/image/fengeLine.svg');
    color: #7F6437;
    box-shadow: none;
    background-size: 15px;
    background-repeat: repeat-x;
    background-position: 0 100%;
    border-radius: 0;
  }
  .cont{
    position: absolute;top: 0;bottom: 0;left:0;right:0;
    background-image: url("../../assets/image/footer.svg");
    background-repeat: no-repeat;
    background-position: 40% 99%;
    background-size: 50%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .wrap2{
    background-color: #F7F3E7;
    height: 100%;
    .tabbar_bg{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 55px;
      background: #9F8E6E;
    }
    .tabbar{
      display: flex;
      overflow-x: auto;
      padding: 0 3px;
      height: 62px;
      background: #FDFCF8;
      .myitem{
        height: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #fffcf6;
        flex-shrink: 0;
        white-space: nowrap;
        background: #c3ae87;
        border: 1px solid #d0ba90;
        border-radius: 5px;
        padding: 2px 5px;
        margin: 5px 5px 0 0;
        position: relative;
        .zh{
          white-space: pre-wrap;
          max-width: 70px;
          min-width: 40px;
          display: inline-block;
          font-size: 0.9rem;
          /*z-index: 1;*/
        }
        .fz06{
          font-size: 0.6rem;
          /*z-index: 1;*/
        }
        .yin{
          display: inline-block;
          font-size: 0.9rem;
          /*z-index: 1;*/
        }
        .num{
          width: 15px;height: 15px;background: red;line-height: 15px;
          text-align: center; color: white;border-radius: 10px;
          position: absolute;top:-5px;right: -5px;font-size:0.6rem;
        }
      }

      .checked{
        position: relative;
        background: #FF7200;
        border: 1px solid #FF7200;
        &:after{
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          left: -1px;
          bottom: -10px;
          border-left: 30px solid #FF7200;
          border-right: 10px solid transparent;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
        }
        &:before{
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          right: -1px;
          bottom: -10px;
          border-left: 10px solid transparent;
          border-right: 30px solid #FF7200;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
        }
      }
    }
  }

  .magin-l-10{
    margin-left: 10px;
  }
  .magin-r-10{
    margin-right: 10px;
  }
  .DSAM{
    position: fixed;
    top:0;
    right:0;
    z-index: 100;
  }
  .home {
    position: absolute;
    top: -2px;
    left: 5px;
    z-index: 110;
  }
  .carQty{
    position: absolute;
    top:-5px;
    right: -5px;
    width: 20px;
    height: 20px;
    background: red;
    border-radius: 10px;
    text-align: center;
    line-height: 20px;
  }

  .swip{
    background: #FDFCF8;
    .my-swipe .van-swipe-item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      background: #FDFCF8;
      padding: 10px;
      .xx{
        width: 49%;
        background: #ffffff;
        .ctmsg{
          display: flex;
          padding: 5px 5px 0 5px;
          span{
            &:first-child{flex: 1;}
            &:last-child{color: #FF6D00;font-size: 0.9rem}
          }
        }
        .msg{
          padding: 0 5px;
          font-size: 0.8rem;
          color: #777;
          margin-top: 0.3rem;
        }
        .img{
          height: 110px;
          overflow: hidden;
          border-radius: 5px;
          position: relative;
          img{
            width: 100%;
          }
          div{
            position: absolute;
            bottom: 0;
            right: 0;
            color: #fffcf6;
            text-align: right;
            width: 100%;
            background-color: rgba(51, 51, 51, 0.5);
            padding: 0.3rem 0.5rem;
            font-size: 0.8rem;
          }
        }
      }
    }

    .custom-indicator{
      text-align: center;
      padding-bottom: 0.3rem;
      span{
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #bebebe;
        border-radius: 50%;
        margin: 0 3px;
        &.checked{
          background: #333333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/routerPages/orderv2.vue